import { defineMessages } from 'react-intl';

export const columnsMultiSelectMessages = defineMessages({
  headerTitle: { id: 'columnsStep.employees', defaultMessage: 'Kolumny' },
  selectAll: { id: 'columnsStep.employees.all', defaultMessage: 'wszystkie' },
  deselectAll: { id: 'columnsStep.employees.none', defaultMessage: 'żadna' },
  bodyLabel: { id: 'columnsStep.employees.choose', defaultMessage: 'Wybierz kolumny' },
  footerTitle: { id: 'columnsStep.employees.footer', defaultMessage: 'Wybrane kolumny' },
});
